import {EventKind} from "../../../enums/event-kind";

export class EventCreationModel {
  constructor(name: string, start: Date, end: Date, locationLinkers: EventCreationLocationLinker[] | undefined, options: EventCreationOptions | undefined) {
    this.name = name;
    this.start = start;
    this.end = end;
    this.locationLinkers = locationLinkers;
    this.options = options;
  }

  name: string;
  start: Date;
  end: Date;

  /**
   * The requested kind (#664). Assigned after construction rather than through the constructor so the two
   * existing call sites in `EventsComponent.create()` stay untouched — the whole batch is stamped in one pass.
   *
   * It is a *request*: a window covered by a 0-device contract coerces it to {@link EventKind.Virtual}, which
   * is why the series preview shows the server's dry-run verdict rather than this field.
   */
  kind: EventKind = EventKind.Real;

  locationLinkers: EventCreationLocationLinker[] | undefined;
  options: EventCreationOptions | undefined;
}

export class EventCreationLocationLinker {
  constructor(location: string, configuration: string | undefined) {
    this.location = location;
    this.configuration = configuration
  }

  location: string;
  configuration: string | undefined;
}

export class EventCreationOptions {
  constructor(isPublic: boolean, responseEnd: Date, hideInShiftMaker: boolean = false) {
    this.public = isPublic;
    this.responseEnd = responseEnd;
    this.hideInShiftMaker = hideInShiftMaker;
  }

  public: boolean = false;
  responseEnd: Date;

  /**
   * Keep every occurrence off the Dienstplan board.
   *
   * A defaulted third constructor argument rather than a required one, so the two `new EventCreationOptions(…)`
   * call sites that predate it keep compiling and keep meaning "shown".
   */
  hideInShiftMaker: boolean = false;
}
